// extracted by mini-css-extract-plugin
export default {"tile":"similar-to-you3bFxfF","tile--super-offer":"similar-to-yous3vhMN","tile__anchor":"similar-to-youfea-Mw","tile__actions":"similar-to-youN8SWfN"};